import { css } from '@emotion/react';

export const authorWrapWidth = 70;
export const authorSize = 50;
export const authorSpacing = 4;
export const messageLaneWidth = `calc(100% - ${(authorWrapWidth + authorSpacing) * 2}px)`;
export const messageLaneLeftPadding = 20;
export const messageLaneRightPadding = 27;

export const messageWidth = 450;
export const extendedMessageWidth = 700;
export const fullChatExtendedMessageWidth = 800;
export const smallWidthBreakpoint = 500;

const authorWrapCss = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: `clamp(44px, 14cqi, ${authorWrapWidth}px)`,
  [`@container (max-width: ${smallWidthBreakpoint}px)`]: {
    display: 'none',
  },
});

// Side Panel only: flush-aligns the avatar to the row edge (matching the header icon inset) instead of centering it in the wider slot, and keeps shrinking instead of hiding at narrow widths.
const sidePanelAuthorMinSize = 18;

const sidePanelAuthorWrapCss = (align: 'flex-start' | 'flex-end', edgeGap: number) =>
  css([
    authorWrapCss,
    {
      alignItems: align,
      minWidth: `clamp(${sidePanelAuthorMinSize}px, 10cqi, ${authorSize}px)`,
      [align === 'flex-start' ? 'paddingLeft' : 'paddingRight']: edgeGap,
      [`@container (max-width: ${smallWidthBreakpoint}px)`]: {
        display: 'flex',
      },
    },
  ]);

export const sidePanelSystemAuthorWrapCss = sidePanelAuthorWrapCss('flex-start', 2);
export const sidePanelUserAuthorWrapCss = sidePanelAuthorWrapCss('flex-end', 0);

const authorCss = css({
  width: `clamp(32px, 10cqi, ${authorSize}px)`,
  height: `clamp(32px, 10cqi, ${authorSize}px)`,
  boxSizing: 'border-box',
});

export const sidePanelAuthorCss = css({
  width: `clamp(${sidePanelAuthorMinSize}px, 8cqi, ${authorSize}px)`,
  height: `clamp(${sidePanelAuthorMinSize}px, 8cqi, ${authorSize}px)`,
  boxSizing: 'border-box',
});

const rootCss = css({
  display: 'flex',
  alignItems: 'flex-start',
  containerType: 'inline-size',
});

const bodyCss = css({
  padding: 15,
  borderRadius: 6,
  maxWidth: messageWidth,
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word',
  boxSizing: 'border-box',
});

export const messageStyles = {
  author: authorCss,
  authorWrap: authorWrapCss,
  body: bodyCss,
  root: rootCss,
};
